import Login from '../components/pages/Login';
import { GetStaticProps } from 'next';

export default Login;
export const getStaticProps: GetStaticProps = async () => ({
        props: {},
    });
